module.exports = __webpack_public_path__ + "img/20190418_154809_001.0b45cd3b.jpg";